import { PdpScoreStatus, PdpStatus } from '@vizit/api';
import type { ProductListingData } from '@vizit/molecules';

const REFRESHABLE_STATUSES = new Set([PdpStatus.ScrapeDone, PdpStatus.Error]);
const REFRESHABLE_SCORE_STATUSES = new Set([PdpScoreStatus.Scored, PdpScoreStatus.CategoryNotFound]);

export function isRefreshAllowed(item: ProductListingData): boolean {
  return (
    (!item.status || REFRESHABLE_STATUSES.has(item.status)) &&
    (!item.scoreStatus || REFRESHABLE_SCORE_STATUSES.has(item.scoreStatus))
  );
}
